// frontend/src/axiosConfig.js
import axios from 'axios';

// ---- 1) Prefer the explicit env var (Render/production) ----
const envBase =
  typeof process !== 'undefined' &&
  process.env &&
  process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL.replace(/\/$/, '')
    : undefined;

// ---- 2) Smart fallback for local dev (desktop & Android emulator) ----
let fallbackBase;
if (typeof window !== 'undefined') {
  const host = window.location.hostname; // e.g., 'localhost', '10.0.2.2', 'www.coinzetto.com'
  const isDevHost =
    host === 'localhost' || host === '127.0.0.1' || host === '10.0.2.2';

  if (isDevHost) {
    // Use the same host for API to support emulator/desktop without edits
    fallbackBase = `http://${host}:5000/api/auth`;
  }
}

// ---- 3) Configure axios (keeps cookies) ----
axios.defaults.withCredentials = true;
axios.defaults.baseURL = envBase || fallbackBase || '/api/auth'; // final fallback supports proxy setups

// ---- 4) Optional: send Bearer token if present (harmless if unused) ----
axios.interceptors.request.use((config) => {
  try {
    const t = localStorage.getItem('token');
    if (t && !config.headers?.Authorization) {
      config.headers = { ...config.headers, Authorization: `Bearer ${t}` };
    }
  } catch {
    // ignore if localStorage not available
  }
  return config;
});

export default axios;
